(function() {
    'use strict';

    angular.module('caffeprint')
        .directive('cpEnterPressEvent', cpEnterPressEvent);

    cpEnterPressEvent.$inject = [];

    function cpEnterPressEvent() {
        return function (scope, element, attrs) {
            element.bind("keydown keypress", function (event) {
                if(event.which === 13) {
                    scope.$apply(function (){
                        scope.$eval(attrs.cpEnterPressEvent);
                    });

                    event.preventDefault();
                }
            });
        };
    }
})();
